import * as yup from 'yup';

yup.addMethod(yup.string, 'repeat', function () {
  return this.test('repeat', function () {
    const { createError } = this;
    const promises = [];
    const extensions = [];
    for (const ext of document.getElementsByClassName('devices')) {
      const { name, value } = ext.lastChild;
      extensions.push({ name, value });
    }
    for (const field of extensions) {
      const { value, name } = field;
      const promise = new Promise((resolve, reject) => {
        const extAlreadyExists = extensions.find(
          ext => ext.value && (ext.value === value && ext.name !== name)
        );
        if (extAlreadyExists) {
          reject(createError({ message: 'Value repeated', path: name }));
        } else {
          resolve(true);
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'some', function () {
  return this.test('some', function () {
    const { createError } = this;
    const extensions = [];
    for (const ext of document.getElementsByClassName('devices')) {
      const { name, value } = ext.lastChild;
      extensions.push({ name, value });
    }
    return new Promise((resolve, reject) => {
      const extAlreadyExists = extensions.every(ext => !ext.value);
      if (extAlreadyExists) {
        reject(
          createError({
            message: 'No items selected',
            path: extensions[0].name
          })
        );
      } else {
        resolve(true);
      }
    });
  });
});

const schema = yup.object().shape({
  voicePanel: yup
    .string()
    .required()
    .trim(),
  ebs: yup
    .string()
    .required()
    .trim(),
  devices: yup
    .string()
    .repeat()
    .some()
});

export default schema;
